"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = require("lodash");
function reduceValue(value) {
    if (_.isFunction(value)) {
        return value;
    }
    if (_.isArray(value)) {
        return value.map(reduceValue);
    }
    if (_.isObject(value)) {
        return reduceObject(value, {});
    }
    return null;
}
function reduceObject(obj, source) {
    return Object.keys(obj).reduce(function (acc, k) {
        var value = reduceValue(obj[k]);
        if (value) {
            acc[k] = value;
        }
        return acc;
    }, source);
}
function propsSerializer(obj) {
    var serialized = { __serializedData: JSON.stringify(obj) };
    reduceObject(obj, serialized);
    return serialized;
}
exports.propsSerializer = propsSerializer;
function propsDeserializer(obj) {
    var __serializedData = obj.__serializedData, rest = tslib_1.__rest(obj, ["__serializedData"]);
    var deserialized = JSON.parse(__serializedData);
    Object.keys(deserialized).forEach(function (k) {
        if (deserialized[k] === null) {
            rest[k] = null;
        }
    }, rest);
    return _.mergeWith({}, deserialized, rest, function (a, b) {
        return b === null ? a : undefined;
    });
}
exports.propsDeserializer = propsDeserializer;
function withPropsSerialization(setProps) {
    var cache = {};
    return function (props) {
        var nextCache = _.omit(cache, Object.keys(props));
        var nextProps = _.merge({}, props, nextCache);
        cache = nextProps;
        setProps(propsSerializer(nextProps));
    };
}
exports.withPropsSerialization = withPropsSerialization;
//# sourceMappingURL=propsSerializer.js.map